import type {
  AdminAutoMatchConfigDeleteRequest,
  AdminAutoMatchConfigItemDto,
  AdminAutoMatchConfigSaveRequest,
  AdminListAutoMatchConfigResponse,
} from '@/venit/services/model/techpubs-cms';
import axios, { type AxiosResponse } from 'axios';

export default class ImportAutoMatchConfigService {
  public list(): Promise<AxiosResponse<AdminListAutoMatchConfigResponse>> {
    return axios.post<AdminListAutoMatchConfigResponse>('/api/admin/dict/import-properties/auto-match-config/list');
  }

  public save(request: AdminAutoMatchConfigSaveRequest): Promise<AxiosResponse<AdminAutoMatchConfigItemDto>> {
    return axios.post<AdminAutoMatchConfigItemDto>('/api/admin/dict/import-properties/auto-match-config/save', request);
  }

  public delete(request: AdminAutoMatchConfigDeleteRequest): Promise<AxiosResponse<void>> {
    return axios.post<void>('/api/admin/dict/import-properties/auto-match-config/delete', request);
  }
}
